import { render, staticRenderFns } from "./EmployeeHistoryWindow.vue?vue&type=template&id=63d0ec64&"
import script from "./EmployeeHistoryWindow.vue?vue&type=script&lang=js&"
export * from "./EmployeeHistoryWindow.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeHistoryWindow.vue?vue&type=style&index=0&id=63d0ec64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports